import React, { useState, useEffect } from 'react';
import { StyledDownloadButton } from './downloadButton.styles';
import { useIntl } from 'react-intl';
import html2pdf from 'html2pdf.js';
import { handlePDFGeneration } from '../../../helpers/pdfDownload';

// Add this at the top of the file for TypeScript
declare global {
  interface Window {
    triggerReportDownload?: () => void;
  }
}

const DownloadButton: React.FC = () => {
  const intl = useIntl();
  const [isGenerating, setIsGenerating] = useState(false);

  return (
    <StyledDownloadButton onClick={handlePDFGeneration} disabled={isGenerating}>
      {isGenerating
        ? intl.formatMessage({ id: 'generatingPDF' })
        : intl.formatMessage({ id: 'downloadPDF' })}
    </StyledDownloadButton>
  );
};

export default DownloadButton;
